import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../../../core/services/alert.service';
import { PackingBoxCreateLabelType } from '../../types/create-label-dialog';

@Injectable()
export class PackingBoxCreateLabelService {
  protected readonly alertService = inject(AlertService);

  form: FormGroup = new FormGroup({
    addSalesOrder: new FormControl<boolean>(true),
    quantity: new FormControl<number>(undefined, [
      Validators.required,
      Validators.min(1),
    ]),
    numLabels: new FormControl<number>(1, [
      Validators.required,
      Validators.min(1),
    ]),
    lotNumber: new FormControl<string>(undefined),
    // Required because the dialog (`PackingBoxCreateLabelComponent.assignPrinters`)
    // always prepends the synthetic "Impresión Local" entry, so the dropdown
    // is never empty. Picking "Impresión Local" routes printing through the
    // Zebra browser bridge (`ZebraService`) on the operator's own machine —
    // it is the explicit fallback when no remote station is available, and
    // is unrelated to the removed `localhost:7575` HTTP path.
    printer: new FormControl<string>(undefined, Validators.required),
  });

  private _maxQuantity: number;
  get maxQuantity(): number {
    return this._maxQuantity;
  }

  setMaxQuantity(max: number): void {
    this._maxQuantity = max;
    this.form.get('quantity').clearValidators();
    this.form
      .get('quantity')
      .setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(max),
      ]);
    this.form.updateValueAndValidity();
  }

  onSave(data: PackingBoxCreateLabelType['data']): {
    addSalesOrder: any;
    quantity: number;
    numLabels: number;
    lotNumberSelected: string;
    printerWithDep?: string;
  } {
    if (this.form.invalid) {
      return;
    }

    const raw = this.form.getRawValue();

    const quantityToDo = raw.quantity * raw.numLabels;

    if (quantityToDo > this._maxQuantity && data.department !== 'Compounding') {
      this.alertService.error(
        `La cantidad dada de ${quantityToDo} es mayor a la cantidad máxima de ${this._maxQuantity}`
      );
      return;
    }

    const printerWithDepartment: string | undefined | null =
      this.form.get('printer')?.value;

    const res = {
      addSalesOrder: data.salesOrder ? raw.addSalesOrder : false,
      quantity: raw.quantity,
      numLabels: raw.numLabels,
      lotNumberSelected: raw.lotNumber,
      printerWithDep: printerWithDepartment,
    };

    this.form.reset();
    this.form.get('numLabels').setValue(1);
    this.form.get('addSalesOrder').setValue(true);

    return res;
  }
}
